import React, { useState, useEffect } from 'react';
import './ProjectsPage.css';
  import { getCachedData } from './cacheService'; 
function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState('all');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  useEffect(() => {
    fetch('/Data/db.json')
      .then(res => res.json())
      .then(data => { if (data.projects) setProjects(data.projects); })
      .catch(err => console.error("Error:", err));
  }, []);
// adjust path

useEffect(() => {
  getCachedData().then(data => {
    if (data.projects) setProjects(data.projects);
  });
}, []);
  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.type === filter);

  const openModal = (index) => {
    setModalIndex(index);
    setModalOpen(true);
  };

  return (
    <div className="projects-page-wrapper">
      {/* --- Cinema Hero Section --- */}
      <div className="video-hero-container">
  {/* Layer 1: The Blurred Background (Stretched to fill) */}
  <video
    className="hero-video-blur-bg"
    src="/assets/ProjectsGallery/videoss/video2.mp4"
    autoPlay loop muted playsInline
  />
  
  {/* Layer 2: The Actual Video (Centered and whole) */}
  <video
    className="hero-video-foreground"
    src="/assets/ProjectsGallery/videoss/video_1.mp4"
    autoPlay loop muted playsInline
  />

  <div className="hero-content-overlay">
    <div className="text-box">
      <h1>Our Project Showcase</h1>
      <div className="divider"></div>
      <p>Quality craftsmanship in every detail</p>
    </div>
  </div>
</div>

      {/* --- Premium Filter Tabs --- */}
      <div className="filter-navigation">
        <button className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>All Projects</button>
        <button className={filter === 'image' ? 'active' : ''} onClick={() => setFilter('image')}>Photos</button>
        <button className={filter === 'video' ? 'active' : ''} onClick={() => setFilter('video')}>Videos</button>
      </div>

      {/* --- Elegant Media Grid --- */}
      <div className="project-grid">
        {filteredProjects.map((p, idx) => (
          <div key={p.id} className="project-card" onClick={() => openModal(idx)}>
            <div className="card-media-box">
              {p.type === 'video' ? (
                <>
                  <video src={p.url} muted playsInline onMouseOver={e => e.target.play()} onMouseOut={e => {e.target.pause(); e.target.currentTime = 0;}} />
                  <div className="play-hint"><span>VIDEO</span></div>
                </>
              ) : (
                <img src={p.url} alt={p.title} />
              )}
            </div>
            <div className="card-info">
            </div>
          </div>
        ))}
      </div>

      {/* --- Lightbox Modal --- */}
      {modalOpen && filteredProjects[modalIndex] && (
        <div className="lightbox-overlay" onClick={() => setModalOpen(false)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setModalOpen(false)}>✕</button>
            {filteredProjects[modalIndex].type === 'image' ? (
              <img src={filteredProjects[modalIndex].url} alt="Project" />
            ) : (
              <video key={filteredProjects[modalIndex].url} controls autoPlay src={filteredProjects[modalIndex].url} />
            )}
            <h3>{filteredProjects[modalIndex].title}</h3>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectsPage;
